import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import FuzzySearchBar from '../career-search/FuzzySearchBar';
import Loading from '../utility/Loading';
import {
  getEligibleUnassignedAdvisorsForUser,
  assignAdvisorsToUser,
  unassignAdvisorFromUser,
} from '../../store/actions';

class AssignAdvisors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayDropDown: false,
      advisorsList: [],
      loading: true,
      listToSearch: [],
    };
    this.dropdown = React.createRef();
    this.openDropdownButton = React.createRef();
  }

  componentDidMount = async () => {
    window.addEventListener('click', (e) => this.closeDropdown(e));
    this._isMounted = true;
  };

  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener('click', (e) => this.closeDropdown(e));
  };

  borderBottomSecondary = (color) => {
    return { borderBottom: `4px solid ${color}` };
  };

  greyBackground = {
    backgroundColor: 'rgba(239, 239, 239, 0.39)',
  };

  disabledCheckbox = {
    border: '1px solid #C3C3C3',
  };

  submitButton = {
    color: `${this.props.tenant.primary}`,
  };

  setFilteredOptionsList = (result) => {
    if (this._isMounted) {
      this.setState({
        advisorsList: result,
      });
    }
  };

  setOptionsLoading = () => {};

  handleCheckbox = (advisor) => {
    const array = ['advisorsList', 'listToSearch'];
    array.forEach((i) => {
      const clone = cloneDeep(this.state[i]);
      const changed = clone.map((x) => {
        const obj = { ...x };
        if (obj.advisorId === advisor.advisorId) {
          obj.checked = !advisor.checked;
        }
        return obj;
      });
      if (this._isMounted) {
        this.setState({
          [i]: changed,
        });
      }
    });
  };

  handleAssignAdviors = async (checkedAdvisors) => {
    const advisorIds = checkedAdvisors.map((x) => x.advisorId);
    await this.props.assignAdvisorsToUser(
      this.props.user.id,
      this.props.user.tenantId,
      advisorIds
    );
    await this.props.handleGetUsers(false);
    if (this._isMounted) {
      this.setState({
        displayDropDown: false,
      });
    }
  };

  displayAssignableAdvisors = () => {
    const { advisorsList } = this.state;
    const checkedAdvisors = advisorsList.filter((x) => x.checked);
    if (this.state.displayDropDown && this.state.loading) {
      return (
        <div className="assign-advisors__dropdown" ref={this.dropdown}>
          <Loading height="100%" />
        </div>
      );
    }
    if (this.state.displayDropDown && !this.state.loading) {
      return (
        <div className="assign-advisors__dropdown" ref={this.dropdown}>
          <FuzzySearchBar
            inputText="Search"
            tenant={this.props.tenant}
            listToSearch={this.state.listToSearch}
            sendFilteredListToParent={this.setFilteredOptionsList}
            setSearchListLoadingOnParent={this.setOptionsLoading}
            searchKeys={['advisorName']}
          />
          {advisorsList.length === 0 ? (
            <p className="assign-advisors__advisor-ul">
              There are currently no advisors assignable to this user
            </p>
          ) : (
            <ul className="assign-advisors__advisor-ul">
              {advisorsList.map((x) => {
                return (
                  <li
                    className={
                      checkedAdvisors.length === 3 && !x.checked
                        ? 'assign-advisors__check-advisor-li assign-advisors__disabled'
                        : 'assign-advisors__check-advisor-li'
                    }
                    style={x.checked ? this.greyBackground : null}
                    key={`${this.props.user.name}_${x.advisorName}`}
                  >
                    <input
                      type="checkbox"
                      className="assign-advisors__checkbox"
                      style={
                        checkedAdvisors.length === 3 && !x.checked
                          ? this.disabledCheckbox
                          : null
                      }
                      checked={x.checked}
                      disabled={checkedAdvisors.length === 3 && !x.checked}
                      onChange={() => {
                        this.handleCheckbox(x);
                      }}
                    />
                    <p>{x.advisorName}</p>
                  </li>
                );
              })}
            </ul>
          )}
          <div className="assign-advisors__button-section">
            <button
              className="assign-advisors__cancel-button"
              type="button"
              onClick={() => {
                if (this._isMounted) {
                  this.setState({ displayDropDown: false });
                }
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="assign-advisors__submit-button"
              disabled={checkedAdvisors.length === 0}
              style={this.submitButton}
              onClick={() => {
                this.handleAssignAdviors(checkedAdvisors);
              }}
            >
              Submit
            </button>
          </div>
        </div>
      );
    }
  };

  closeDropdown = (e) => {
    if (
      !this.dropdown?.current?.contains(e.target) &&
      !this.openDropdownButton?.current?.contains(e.target) &&
      e.target.id !==
        `add-button-${this.props.user.id}_${this.props.user.tenantId}_advisor`
    ) {
      if (this._isMounted) {
        this.setState({ displayDropDown: false });
      }
    }
  };

  showAdvisors = async () => {
    if (this._isMounted) {
      this.setState({
        displayDropDown: true,
        loading: true,
      });
      const advisors = await this.props.getEligibleUnassignedAdvisorsForUser(
        this.props.user.tenantId,
        this.props.user.id,
        this.props.highSchool
      );
      this.setState({
        loading: false,
        advisorsList: advisors,
      });
    }
  };

  removeAdvisor = async (advisor) => {
    await this.props.unassignAdvisorFromUser(
      this.props.user.id,
      this.props.user.tenantId,
      advisor.advisorId
    );
    await this.props.handleGetUsers(false);
  };

  displayPlusOrXIcon = (advisor) => {
    return advisor ? (
      <button
        className="assign-advisors__add-button"
        ref={this.openDropdownButton}
        type="button"
        onClick={() => {
          this.removeAdvisor(advisor);
        }}
      >
        x
      </button>
    ) : (
      <button
        className="assign-advisors__add-button"
        id={`add-button-${this.props.user.id}_${this.props.user.tenantId}_advisor`}
        ref={this.openDropdownButton}
        type="button"
        onClick={this.showAdvisors}
      >
        +
      </button>
    );
  };

  displayAssignedAdvisors = () => {
    if (this.props.user.assignedAdvisors?.length === 0) {
      return (
        <>
          <p className="assign-advisors__advisor-list">Unassigned</p>
          <button
            className="assign-advisors__add-button"
            ref={this.openDropdownButton}
            type="button"
            onClick={this.showAdvisors}
          >
            +
          </button>
          {this.displayAssignableAdvisors()}
        </>
      );
    }
    if (this.props.user.assignedAdvisors?.length < 3) {
      return (
        <div className="assign-advisors__column-of-advisors">
          {this.props.user.assignedAdvisors?.map((advisor) => {
            return (
              <div
                className="assign-advisors__row"
                key={`${this.props.user.name}_${advisor.advisorName}`}
              >
                <p className="assign-advisors__advisor-list">
                  {advisor?.advisorName}
                </p>
                {this.displayPlusOrXIcon(advisor)}
              </div>
            );
          })}
          <div className="assign-advisors__row">
            <p className="assign-advisors__advisor-list">Add another</p>
            {this.displayPlusOrXIcon(false)}
            {this.displayAssignableAdvisors()}
          </div>
        </div>
      );
    }
    return (
      <div className="assign-advisors__column-of-advisors">
        {this.props.user.assignedAdvisors?.map((advisor) => {
          return (
            <div className="assign-advisors__row">
              <p className="assign-advisors__advisor-list">
                {advisor?.advisorName}
              </p>
              {this.displayPlusOrXIcon(advisor)}
              {this.displayAssignableAdvisors()}
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    return (
      <div className="assign-advisors">
        <p className="assign-advisors__advisor-text">
          Advisor:
          {(this.props.user.tenantId !== 2 ||
            this.props.user.role !== 'Student') &&
            ' N/A'}
        </p>
        {this.props.user.tenantId === 2 &&
          this.props.user.role === 'Student' &&
          this.displayAssignedAdvisors()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const tenant = state.tenant;
  return { tenant };
}

export default withRouter(
  connect(mapStateToProps, {
    getEligibleUnassignedAdvisorsForUser,
    assignAdvisorsToUser,
    unassignAdvisorFromUser,
  })(AssignAdvisors)
);
